import { camelCase, isObject, kebabCase, transform } from 'lodash-es'

export function transformType(type) {
  return kebabCase(type)
}

export function transformKeysDeep(props) {
  return transform(props, function (result, value, key) {
    const currentKey = camelCase(key)

    result[currentKey] = isObject(value) ? transformKeysDeep(value) : value
  })
}
